//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Service from '@/service/building'

import HouseItem from './_house_item'
import { sendUserLog } from '@/utils/log'

import RankPage from '../_building_rank/_page'
import recommend from '../_building_rank/recommend'
import { WHOLE_CITY, handleItems, getViewCount } from '../_building_rank/utils'


const NAME_MAP = {
    comments: '热评榜',
    views: '人气榜',
    follows: '关注榜'
}

export default {
    mixins: [
        recommend
    ],
    components: {
        RankPage,
        HouseItem
    },
    data () {
        return {
            description: '',
            zones: [],
            items: [],
            ranking_types: {},
            loading: true,
            types: [
                {
                    value: 'comments',
                    text: NAME_MAP['comments'],
                    view_count: ''
                },
                {
                    value: 'views',
                    text: NAME_MAP['views'],
                    view_count: ''
                },
                {
                    value: 'follows',
                    text: NAME_MAP['follows'],
                    view_count: ''
                }
            ],
            type: 'comments',
            zone: '',
        }
    },
    computed: {
        name () {
            return NAME_MAP[this.type]
        }
    },
    mounted () {
        const { zone, type } = this.$route.query
        this.zone = zone || WHOLE_CITY
        this.type = type
        this.getData()
    },
    methods: {
        getData () {
            wx.showLoading()
            this.loading = true
            const zone = this.zone === WHOLE_CITY ? '' : this.zone
            Service.getBuildingRanks(this.type, zone).then(({ zones, items, ranking_types, page_view_counts, description }) => {
                this.description = description
                this.zones = [WHOLE_CITY].concat(zones)
                if (page_view_counts) {
                    this.types.forEach((item) => {
                        item.view_count = getViewCount(item, page_view_counts)
                    })
                }
                this.items = handleItems(items)
                this.ranking_types = ranking_types
                wx.hideLoading()
                this.loading = false
                this.checkRecommend(this.type, this.items, zone)
            })
            sendUserLog('fc_ranking_visit', {
                d_key: this.type,
                d_event: 0
            })
        },
        changeZone (zone) {
            this.zone = zone
            this.items = []
            this.getData()
        },
        changeType (type) {
            this.type = type
            this.items = []
            this.getData()
        }
    }
}
